import React, { useState, useRef } from 'react';
import { colors } from '../../../constants';

const REPLIT_URL = 'https://analytics-dashboard-scottv-arohomes.replit.app';

function MarketResearch() {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const iframeRef = useRef(null);

    const handleLoad = () => setLoading(false);
    const handleError = () => {
        setLoading(false);
        setError(true);
    };

    const handleRefresh = () => {
        setLoading(true);
        setError(false);
        if (iframeRef.current) {
            iframeRef.current.src = REPLIT_URL;
        }
    };

    return (
        <div className="container-fluid px-0">
            {/* Header bar */}
            <div
                className="d-flex align-items-center justify-content-between px-2 py-2"
                style={{
                    background: colors.charcoalDark,
                    borderBottom: `1px solid ${colors.charcoal}`,
                    fontFamily: '\'IBM Plex Mono\', monospace',
                }}
            >
                {/* URL bar */}
                <div
                    className="d-flex align-items-center gap-2 px-3 py-1 rounded"
                    style={{
                        background: colors.charcoalDark,
                        border: `1px solid ${colors.charcoal}`,
                        flex: '0 1 480px',
                        minWidth: 0,
                    }}
                >
                    <svg
                        width="12"
                        height="12"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#4ade80"
                        strokeWidth="2.5"
                    >
                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                    </svg>
                    <span
                        className="text-truncate"
                        style={{ color: '#8b8fa8', fontSize: 12, letterSpacing: '0.01em' }}
                    >
                        {REPLIT_URL}
                    </span>
                </div>

                {/* Actions */}
                <div className="d-flex align-items-center gap-2">
                    <button
                        onClick={handleRefresh}
                        className="btn btn-sm d-flex align-items-center gap-1"
                        style={{
                            background: '#1c1f2b',
                            border: '1px solid #2a2d3a',
                            color: '#8b8fa8',
                            fontSize: 12,
                            padding: '4px 10px',
                            fontFamily: '\'IBM Plex Mono\', monospace',
                        }}
                        title="Refresh"
                    >
                        <svg
                            width="12"
                            height="12"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                        >
                            <polyline points="23 4 23 10 17 10" />
                            <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
                        </svg>
            Refresh
                    </button>
                    <a
                        href={REPLIT_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-sm d-flex align-items-center gap-1"
                        style={{
                            background: '#1c1f2b',
                            border: '1px solid #2a2d3a',
                            color: '#8b8fa8',
                            fontSize: 12,
                            padding: '4px 10px',
                            fontFamily: '\'IBM Plex Mono\', monospace',
                            textDecoration: 'none',
                        }}
                        title="Open in new tab"
                    >
                        <svg
                            width="12"
                            height="12"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                        >
                            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                            <polyline points="15 3 21 3 21 9" />
                            <line x1="10" y1="14" x2="21" y2="3" />
                        </svg>
            Open
                    </a>
                </div>
            </div>

            {/* iframe container */}
            <div
                className="position-relative w-100"
                style={{ height: '80vh', background: '#0f1117' }}
            >
                {/* Loading overlay */}
                {loading && !error && (
                    <div
                        className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center"
                        style={{ background: '#0f1117', zIndex: 10 }}
                    >
                        <div
                            className="mb-3"
                            style={{
                                width: 40,
                                height: 40,
                                border: '3px solid #2a2d3a',
                                borderTop: '3px solid #4ade80',
                                borderRadius: '50%',
                                animation: 'spin 0.8s linear infinite',
                            }}
                        />
                        <span
                            style={{
                                color: '#4b5163',
                                fontSize: 13,
                                fontFamily: '\'IBM Plex Mono\', monospace',
                            }}
                        >
              Loading dashboard...
                        </span>
                        <style>
                            {'@keyframes spin { to { transform: rotate(360deg); } }'}
                        </style>
                    </div>
                )}

                {/* Error state */}
                {error && (
                    <div
                        className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center gap-3"
                        style={{ background: '#0f1117', zIndex: 10 }}
                    >
                        <svg
                            width="40"
                            height="40"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#ef4444"
                            strokeWidth="1.5"
                        >
                            <circle cx="12" cy="12" r="10" />
                            <line x1="12" y1="8" x2="12" y2="12" />
                            <line x1="12" y1="16" x2="12.01" y2="16" />
                        </svg>
                        <p
                            style={{
                                color: '#6b7280',
                                fontSize: 14,
                                fontFamily: '\'IBM Plex Mono\', monospace',
                                margin: 0,
                            }}
                        >
              Failed to load app
                        </p>
                        <button
                            onClick={handleRefresh}
                            className="btn btn-sm"
                            style={{
                                background: '#1c1f2b',
                                border: '1px solid #ef4444',
                                color: '#ef4444',
                                fontSize: 12,
                                fontFamily: '\'IBM Plex Mono\', monospace',
                            }}
                        >
              Try again
                        </button>
                    </div>
                )}

                <iframe
                    ref={iframeRef}
                    src={REPLIT_URL}
                    title="Analytics Dashboard"
                    onLoad={handleLoad}
                    onError={handleError}
                    style={{
                        width: '100%',
                        height: '100%',
                        border: 'none',
                        display: 'block',
                        opacity: loading ? 0 : 1,
                        transition: 'opacity 0.3s ease',
                    }}
                    allow="fullscreen"
                />
            </div>
        </div>
    );
}
export default MarketResearch;
